module.exports = __webpack_public_path__ + "img/5.81a6e78a.jpg";